module.exports = __webpack_public_path__ + "static/media/fm_policy_letr.e4fc9296.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/fm_policy_letr.svg
// module id = 672
// module chunks = 0